export default __webpack_public_path__ + "static/media/arun-modified.fe29dee3.png";